import React from "react";
import { useSelector } from "react-redux";
import { Box, Grid, makeStyles } from "@material-ui/core";

import ConversionWidget from "./ConversionWidget";
import TargetProgressWidget from "./TargetProgressWidget";
import { getMetric1IdAndValue, getMetric2IdAndValue } from "../../../../store/hub/organisationConversionData";
import { getSelectedTimePeriod } from "../../../../store/ui/conversion";

export default function OrganisationConversionWidget() {
  const classes = useStyles();
  const selectedTimePeriod = useSelector((state) => getSelectedTimePeriod(state.ui.conversion));
  const metric1IdAndValue = useSelector((state) =>
    getMetric1IdAndValue(state.entities.organisationConversionData, selectedTimePeriod)
  );
  const metric2IdAndValue = useSelector((state) =>
    getMetric2IdAndValue(state.entities.organisationConversionData, selectedTimePeriod)
  );
  const showOrganisationStats = metric1IdAndValue != null;
  const showTargetWidget = metric1IdAndValue?.targetText != null && metric1IdAndValue?.target != null;

  if (!showOrganisationStats) return null;

  return (
    <Box className={classes.container} width="100%">
      <Grid container spacing={2} className={classes.grid}>
        <ConversionWidget
          metric1IdAndValue={metric1IdAndValue}
          metric2IdAndValue={metric2IdAndValue}
          paperClassName={classes.compactPaper}
        />
        {showTargetWidget && (
          <TargetProgressWidget
            metricIdAndValue={metric1IdAndValue}
            paperClassName={classes.compactPaper}
            compact
          />
        )}
      </Grid>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: 0,
  },
  compactPaper: {
    [theme.breakpoints.up("sm")]: {
      marginBottom: 10,
    },
  },
  grid: {
    [theme.breakpoints.only("xs")]: {
      justifyContent: "flex-start",
      flexWrap: "nowrap",
      overflowX: "scroll",
    },
    [theme.breakpoints.up("sm")]: {
      justifyContent: "flex-start",
    },
  },
}));
